var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_3268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_3268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8H28V0H0V8Z",
    fill: "#B9414B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V12H0V20Z",
    fill: "#B9414B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLv);
export default __webpack_public_path__ + "static/media/lv.3e3dd6423e4243ef76ae3cd738f2c4ab.svg";
export { ForwardRef as ReactComponent };